import { TableCell, TableRow } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { MasterButton, Modal } from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { DISABLED_BUTTON_SUBMIT } from "App/constants";
import { useDatatables } from "App/hooks";
import { defaultDateDisplay } from "App/utils/helpers";
import { FreezeTableClient } from "components/organism";
import React, { useState } from "react";
import { StatusKunjungan } from "../../../utils";

function ModalForceAsuransi({ setShowModal, rows, handleSubmit }) {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const [disabled, setDisabled] = useState({
    state: false,
    label: "Ya, saya yakin",
    color: "#0FB054",
  });

  const handleClick = async (e) => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    await handleSubmit(e, true);
    setShowModal(false);
  };

  return (
    <Modal width='60%' title={`Konfirmasi Registrasi`} show={setShowModal}>
      <div className='mt-1 mb-1'>
        <Alert severity='warning'>
          <AlertTitle>Warning</AlertTitle>
          RM <strong>{rows[0]?.patients_id}</strong> sudah terdaftar sebanyak{" "}
          <strong>{rows.length}</strong> Apakah anda yakin ingin mendaftarkannya
          lagi?
        </Alert>
      </div>

      <MasterButton
        className={"mb-1"}
        onClick={(e) => handleClick(e)}
        type='button'
        style={{
          display: "flex",
          width: "100%",
          textAlign: "center",
          justifyContent: "center",
          padding: "0.8rem",
          fontSize: "14px",
        }}
        color={disabled.color}
        disabled={disabled.state}
        name={disabled.label}
        size='lg'
      />

      <FreezeTableClient
        title='Daftar Kunjungan'
        setQ={setQ}
        withSearch={false}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow key={index}>
                <TableCell align='center'>{index + 1}</TableCell>
                <TableCell align='left'>{row?.id}</TableCell>
                <TableCell align='left'>{row?.patients_id}</TableCell>

                <TableCell align='left'>{row?.tagihan_id}</TableCell>
                <TableCell align='left'>
                  {defaultDateDisplay(row?.date, true)}
                </TableCell>

                <TableCell align='center'>
                  <StatusKunjungan
                    status={row.status}
                    iscancel={row.iscancel}
                  />
                </TableCell>
                <TableCell align='left'>{row?.nohp}</TableCell>
                <TableCell align='left'>{row?.rm_phone_number}</TableCell>

                <TableCell align='left'>{row?.insurance_no}</TableCell>
                <TableCell align='left'>{row?.no_sep}</TableCell>

                <TableCell align='left'>
                  {row?.initial}-{row?.antrianno}
                </TableCell>

                <TableCell align='left'>
                  {row?.isexternalrm
                    ? defaultDateDisplay(row?.date_ob_external, false)
                    : defaultDateDisplay(row?.date_ob, false)}
                </TableCell>

                <TableCell align='left'>{row?.umur}</TableCell>

                <TableCell align='left'>{row.nama_ppk_perujuk}</TableCell>
                <TableCell align='left'>{row?.nama_hak_kelas}</TableCell>

                <TableCell align='left'>{row?.whycancel}</TableCell>
              </TableRow>
            );
          })}
      </FreezeTableClient>
    </Modal>
  );
}

export default ModalForceAsuransi;

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    minWidth: "40px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "patients_id",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "tagihan_id",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL REGISTRASI",
    align: "left",
    minWidth: "200px",
  },

  {
    id: "iscancel",
    disablePadding: false,
    label: "STATUS",
    align: "center",
  },
  {
    id: "nohp",
    disablePadding: false,
    label: "NO HP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "rm_phone_number",
    disablePadding: false,
    label: "NO TLP",
    align: "left",
    minWidth: "100px",
  },

  {
    id: "insurance_no",
    disablePadding: false,
    label: "NO ASURANSI",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "nosep",
    disablePadding: false,
    label: "NO SEP",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "antrianno",
    disablePadding: false,
    label: "NO ANTRIAN",
    align: "left",
    minWidth: "140px",
  },

  {
    id: "date_ob",
    disablePadding: false,
    label: "TANGGAL LAHIR",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "umur",
    disablePadding: false,
    label: "UMUR",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "nama_ppk_perujuk",
    disablePadding: false,
    label: "PPK PERUJUK",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "nama_hak_kelas",
    disablePadding: false,
    label: "HAK KELAS",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "whycancel",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    sort: false,
    minWidth: "250px",
  },
];
